import { useThemeStore, type Theme } from '@/stores/theme';
import { THEME_ICON } from '@/lib/theme-options';
import { BAR_ICON_BUTTON_CLASS } from '@/components/layout/bar-styles';

// Orden del ciclo: light -> dark -> system -> light.
const NEXT_THEME: Record<Theme, Theme> = {
  light: 'dark',
  dark: 'system',
  system: 'light',
};

// Etiquetas accesibles dinámicas que describen la siguiente acción.
const NEXT_LABEL: Record<Theme, string> = {
  light: 'Cambiar a tema oscuro',
  dark: 'Cambiar a tema del sistema',
  system: 'Cambiar a tema claro',
};

// Botón accesible que cicla entre los tres estados de tema. Vive en la barra
// superior: lleva sus colores.
// El icono representa la preferencia actual del usuario, no el `resolved`.
export const ThemeToggle = () => {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);

  const handleClick = (): void => {
    setTheme(NEXT_THEME[theme]);
  };

  const Icon = THEME_ICON[theme];

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={NEXT_LABEL[theme]}
      className={BAR_ICON_BUTTON_CLASS}
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
    </button>
  );
};
